exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errors[data-v-625e493f] {\n  color: #f5222d;\n  font-style: italic;\n}\n.has-error[data-v-625e493f] {\n  border-color: #f5222d;\n}\n", ""]);

// exports
